module.exports = __webpack_public_path__ + "img/logo-google.d13d8035.png";